/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import qs from 'querystring';

export default class Context {
  constructor(path, context, router) {
    const url = new URL(`${window.location.origin}${path}`);

    this.fullPath = path;
    this.hash = url.hash ? url.hash.slice(1) : '';
    this.path = url.pathname;
    this.querystring = url.search ? url.search.slice(1) : '';
    this.query = qs.parse(this.querystring);
    this.params = Object.create(null);
    this.router = router;
  }
}
